import { render } from "./Buttons.vue?vue&type=template&id=262f352f"
import script from "./Buttons.vue?vue&type=script&lang=ts"
export * from "./Buttons.vue?vue&type=script&lang=ts"
script.render = render

export default script